import { Currency } from "@redotech/money/currencies";
import { formatAmount } from "@redotech/money/util";
import { AttributedMetric } from "@redotech/redo-marketing-common/attribution";

/** Zero in the store's currency when the entity has no attributed orders. */
export function formatAttributedRevenue(
  metric: AttributedMetric | undefined,
  currency: Currency,
): string {
  return formatAmount(metric?.revenue ?? 0, currency);
}

export function formatAttributedOrders(
  metric: AttributedMetric | undefined,
): string {
  return (metric?.orders ?? 0).toLocaleString();
}
